import React from "react";
import ReactApexChart from "react-apexcharts";

interface ProfessionData {
    profession: string;
    count: number;
}

interface Props {
    professionDistribution: ProfessionData[];
}

const ProfessionDistributionTreeMap: React.FC<Props> = ({
    professionDistribution,
}) => {
    const fillColor = "#5DC6FF";
    const data = (professionDistribution || []).map((entry) => ({
        x: entry.profession,
        y: entry.count,
        fillColor,
    }));

    const options = {
        chart: {
            type: "treemap" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{ data: data }]}
                type="treemap"
                height={350}
            />
        </div>
    );
};

export default ProfessionDistributionTreeMap;
